export enum BubblehousePointsRounding {
  Nearest = "nearest",
  Up = "up",
  Down = "down",
}
